export const EmailRegex = /^[^\s@]+@[^\s@]+\.([a-z]{2,3}(?:\.ar)?)$/
